"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardCVC = exports.CardExpiry = exports.CardNumber = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactStripeElements = require("react-stripe-elements");

var _ui = require("@foundation-lib/ui");

var factory = function factory(Component, defaultLabel) {
  return function (_ref) {
    var InputLabelProps = _ref.InputLabelProps,
        InputProps = _ref.InputProps,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? defaultLabel : _ref$label,
        labelErrorMessage = _ref.labelErrorMessage,
        error = _ref.error,
        other = (0, _objectWithoutProperties2["default"])(_ref, ["InputLabelProps", "InputProps", "label", "labelErrorMessage", "error"]);
    return /*#__PURE__*/_react["default"].createElement(_ui.TextInput, (0, _extends2["default"])({
      label: label,
      helperText: error ? labelErrorMessage || "Invalid ".concat(label) : null,
      hasError: error,
      inputComponent: Component,
      alwaysLabelShrink: true,
      uncontrolled: true
    }, other));
  };
};

var CardNumber = factory(_reactStripeElements.CardNumberElement, 'Credit Card Number');
exports.CardNumber = CardNumber;
var CardExpiry = factory(_reactStripeElements.CardExpiryElement, 'Expiration Date');
exports.CardExpiry = CardExpiry;
var CardCVC = factory(_reactStripeElements.CardCVCElement, 'CVV (3-digit # on back of card)');
exports.CardCVC = CardCVC;